import { FormHelperText, Stack, SxProps, Theme } from "@mui/material";

import { renderIf } from "@/common/helpers/render/renderIf";
import { AssetEntityType, AssetSpecDto } from "@/core/api/generated/v1";

import InlineApiEnumValue from "../../Enum/InlineApiEnumValue";
import InfoTile from "../../Form/Display/InfoTile";
import VehicleSpecDisplay from "../Vehicle/VehicleSpecDisplay";

interface Props {
  tenantId: string | null | undefined;
  spec: AssetSpecDto | null | undefined;
  sx?: SxProps<Theme>;
}

/** Input for duration that works on Moment.js Duration. */
export default function AssetSpecDisplay({ tenantId, spec, sx }: Props) {
  if (!spec) {
    return null;
  }

  return (
    <Stack spacing={1} sx={sx}>
      <InfoTile label='Type' iconOf='data'>
        <InlineApiEnumValue type='AssetEntityType' value={spec?.entityType} />
      </InfoTile>

      {renderIf()
        .if(spec.entityType === AssetEntityType.Vehicle)
        .then(<VehicleSpecDisplay tenantId={tenantId} spec={spec.vehicle} />)
        .elseif(spec.entityType === AssetEntityType.Accessory)
        .then(<></>)
        .else(<FormHelperText error>Unknown asset type {spec.entityType}</FormHelperText>)
        .render()}
    </Stack>
  );
}
